import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from '@mui/material/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';
import ForwardIcon from '@mui/icons-material/Forward';
import MapIcon from '@mui/icons-material/Map';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import EventIcon from '@mui/icons-material/Event';
import SettingsIcon from '@mui/icons-material/Settings';
import InputIcon from '@mui/icons-material/Input';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { styled } from '@material-ui/styles';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import Popover from '@mui/material/Popover';

import api from '../../../../../services/api';
import SNARonda from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/RondaVirtual/snaRonda';

import CadastrarProcedimentoAvulso from './cadastrarProcedimentoAvulso.js';
import CabecalhoInformacoes from './CabecalhoInformacoes.js';
import CabecalhoInformacoes2 from './CabecalhoInformacoes2.js';
import RepassarProcedimento from './repassarProcedimento.js';


import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import {
    DataGrid, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { AddToQueueOutlined, LaptopWindows } from '@material-ui/icons';

import GerenciarTratamentoEmCampo from './gerenciarTratamentoEmCampo';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import ComponentAgendamento from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/Agendamentos/componentAgendamento.js';


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },

    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));



const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));




const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



export default function RequerimentoSaidaEstoque({ flag = 0, ordemServicoIn }) {

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    const themeHelper = {
        bg: darkMode ? "#252525" : "#e9eff3",
        paper: darkMode ? "#2e2e2e" : "#f5f8fa",
        text: darkMode ? "#ffffff" : "#1a1a1a",
        border: darkMode ? "#444444" : "#d1d9e0",
    };

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('temaChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('temaChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
        };
    }, []);

    const themeV5 = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            }
        },
    }), [darkMode]);

    const themeV4 = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
                secondary: darkMode ? '#aaaaaa' : '#666666',
            }
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    },
                } : {},
            },
            MuiFormLabel: {
                root: darkMode ? {
                    color: 'white',
                    '&$focused': {
                        color: 'white'
                    }
                } : {}
            },
            MuiInputBase: {
                input: darkMode ? {
                    color: 'white',
                } : {}
            },
            MuiAutocomplete: {
                root: darkMode ? {
                    '& .MuiInputLabel-root': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                } : {},
                popupIndicator: darkMode ? {
                    color: 'white'
                } : {},
                clearIndicator: darkMode ? {
                    color: 'white'
                } : {},
                paper: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white'
                } : {}
            }
        },
    }), [darkMode]);

    const [informaDialog, setInformaDialog] = useState(true); // abre assim que entra na rota

    const regra = Cookies.get("regra") || "";


    const [ordemServico, setOrdemServico] = useState(ordemServicoIn);

    const [mostrarDialog, setMostrarDialog] = useState(false);


    function handleSetInsumoSelecionado(insumo_) {
        try {
            const insumo = insumo_.insumo;
        } catch (_err) {
            setInsumoSelecionado(null);

            return;
        }


        setInsumoSelecionado(insumo_);
    }





    const classes = useStyles();
    const history = useHistory();

    const [loading, setLoading] = useState(true);

    const [limiar, setLimiar] = useState(900);

    const [larguraOriginal, setLarguraOriginal] = useState(0);







    useEffect(() => {
        // Função que verifica se o modal deve aparecer
        const checarCondicoes = () => {
            if (!ordemServico) return null; // nada a mostrar
            if (ordemServico.solicitacao.id_solicitacao !== 7) return null; // só bloquear para solicitacao 7

            const semItens =
                !ordemServico.itens_pre_requerimento ||
                ordemServico.itens_pre_requerimento.length < 1;
            const finalizarPend =
                ordemServico.itens_pre_requerimento &&
                ordemServico.itens_pre_requerimento.length >= 1 &&
                ordemServico.finalizar_requerimento_itens === 0;

            if (semItens) return "adicionar"; // mostrar mensagem de adicionar itens
            if (finalizarPend) return "finalizar"; // mostrar mensagem de finalizar
            return null; // não precisa mostrar
        };

        // Evento beforeunload (fechar/recarregar aba)
        const handleBeforeUnload = (event) => {
            const acao = checarCondicoes();
            if (acao) {
                event.preventDefault();
                event.returnValue = ""; // bloqueia o fechamento temporariamente
                setTimeout(() => setMostrarDialog(true), 200);
            }
        };

        // Evento mousemove (aproximação do topo da aba)
        const handleMouseMove = (e) => {
            const acao = checarCondicoes();
            if (e.clientY < 50 && acao) {
                setMostrarDialog(true);
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        document.addEventListener("mousemove", handleMouseMove);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, [ordemServico]);


    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setLarguraOriginal(largura);


    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });



    useEffect(() => {

        //alert("Regras: " + regra);

        checkDimenssoes();
        listarInformacoes();

    }, []);



    const [descricao, setDescricao] = useState('');
    const [solicitacaoSelecionada, setSolicitacaoSelecionada] = useState(null);


    const [observacoesItem, setObservacoesItem] = useState('');


    const [usuarioSelecionadoTratarRemoto, setUsuarioSelecionadoTratarRemoto] = useState(null);
    const [usuarioSelecionadoTratarEmCampo, setUsuarioSelecionadoTratarEmCampo] = useState(null);

    function returnDescricaoInsumo2(insumo_) {

        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes

                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                )).join('');
        }

        var texto =

            //"<br />Marca/Modelo: " + insumo.marca + "/" + insumo.modelo +
            // "<br />Código Fornecedor: " + insumo.codigo_fornecedor +
            //"<br />Tipo: " + insumo.tipo +
            //"<br />Categoria: " + insumo.categoria +
            textoComQuebraDeLinha + "<br />Estoque: " + (Array.isArray(insumo_.itens_estoque) ? insumo_.itens_estoque.length : 0) + " unidades";
        return texto;
    }


    function returnDescricaoInsumo(insumo_) {

        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes

                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                )).join('');
        }




        if (insumo.cotacoes && insumo.cotacoes.length > 0) {
            const cotacoesOrdenadas = [...insumo.cotacoes].sort((a, b) => new Date(a.data) - new Date(b.data));

            // Formata número para moeda brasileira
            const formatarValor = (valor) =>
                new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

            // Formata data para pt-BR
            const formatarData = (data) =>
                new Date(data).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

            // 👉 Mantém todas para cálculo, mas pega só as 3 últimas para exibir
            const ultimasTres = cotacoesOrdenadas.slice(-3);

            // Constrói o texto com as 3 últimas cotações formatadas
            textoComQuebraDeLinha += ultimasTres
                .map((cotacao) => {
                    return `<br />*Cotação -> ${formatarValor(cotacao.valor_unitario)} em ${formatarData(cotacao.data)}`;
                })
                .join('');
            const soma = cotacoesOrdenadas.reduce((acc, c) => acc + c.valor_unitario, 0);
            const media = soma / cotacoesOrdenadas.length;
            textoComQuebraDeLinha += `<br />Valor médio: ${formatarValor(media)}`;

            // Última cotação (maior data após ordenação)
            const ultimaCotacao = cotacoesOrdenadas[cotacoesOrdenadas.length - 1];
            textoComQuebraDeLinha += `<br />Última Cotação: ${formatarValor(ultimaCotacao.valor_unitario)} em ${formatarData(ultimaCotacao.data)}`;
        } else {
            textoComQuebraDeLinha += `<br />Sem cotações`;
        }





        var quantidadeDisponivel = 0;

        if (Array.isArray(insumo_.itens_estoque)) {
            quantidadeDisponivel = insumo_.itens_estoque.filter(item => item.status_item === 0).length;
        }

        var texto = textoComQuebraDeLinha + "<br />Estoque: " + quantidadeDisponivel + " unidades";
        return texto;
    }



    function returnDescricaoInsumoSimplificada(insumo) {
        try {
            // Tenta acessar diretamente insumo.descricao
            if (insumo?.descricao) {
                return "Descrição: " + insumo.descricao;
            }

            // Se não houver, tenta insumo.insumo.descricao
            if (insumo?.insumo?.descricao) {
                return "Descrição: " + insumo.insumo.descricao;
            }

            // Se nenhum dos dois funcionar
            return "Descrição: não disponível";
        } catch (error) {
            return "Descrição: erro ao obter";
        }
    }


    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);
    const [quantidade, setQuantidade] = useState(0);

    function handleSetInsumo(insumo) {
        setInsumoSelecionado(insumo);
    }


    async function recarregarItens() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("/v1/protected/ordemservico/listarporid/" + ordemServico.id_ordem_servico, {
                headers: headers
            }).then(function (response) {

                setOrdemServico(response.data);

                setLoading(false);



            });



        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }
    }

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }







        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }


    async function handleImportarItensDaOrdemCompra() {
        try {
            const token = Cookies.get('token');

            const headers = {
                Authorization: 'Bearer ' + token
            };

            const response = await api.get(
                "/v1/protected/ordemservico/importaritensdaordemcompra/" + ordemServico.id_ordem_servico,
                { headers }
            );

            if (response.data) {
                setOrdemServico(response.data);
            }

        } catch (error) {
            console.log("ERRO AO IMPORTAR:", error);

            // 🔥 1. Erro retornado pelo backend (400, 404, 500...)
            if (error.response) {
                console.log("Backend retornou:", error.response.data);

                // Aqui você pode exibir na tela
                alert("Erro: " + (error.response.data?.message || error.response.data));
                return;
            }

            // 🔥 2. Erro de rede (não conectou no servidor)
            if (error.request) {
                alert("Erro de rede: servidor não respondeu.");
                return;
            }

            // 🔥 3. Erro inesperado
            alert("Erro inesperado: " + error.message);
        }
    }



    const [value, setValue] = React.useState(0);



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }






    const handleOpen = (event, cellValues) => {


    }


    const handleClose = () => {
    };











    async function adicionarItem() {



    }







    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };









    async function handleClickRemocao(event, cellValues) {





    };


    const columnsDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 100,
            renderCell: (cellValues) => (
                <ColorButtonRed
                    variant="contained"
                    color="primary"
                    onClick={(event) => handleClickRemocao(event, cellValues)}
                >
                    Remover
                </ColorButtonRed>
            ),
        },
        {
            headerName: 'Item',
            field: 'id_item_na_lista',
            id: 2,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 3,
            width: 350, // 🔹 Metade do tamanho original (700 → 350)
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const insumo = params.row.insumo;
                let descricao = returnDescricaoInsumoSimplificada(insumo);
                descricao = descricao.replace(/<br\s*\/?>/gi, '\n');
                return (
                    <div
                        style={{
                            whiteSpace: 'pre-wrap', // 🔹 Permite quebra automática de linha
                            overflowWrap: 'break-word',
                            wordBreak: 'break-word',
                        }}
                    >
                        {descricao}
                    </div>
                );
            },
        },
        {
            headerName: 'Qtd Pedida',
            field: 'quantidade',
            id: 4,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 7,
            width: 300, // 🔹 Metade do tamanho original (600 → 300)
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => (
                <div
                    style={{
                        whiteSpace: 'pre-wrap', // 🔹 Permite quebra automática
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                    }}
                >
                    {params.value}
                </div>
            ),
        },
    ];

    return (
        <MuiThemeProvider theme={themeV5}>
            <CoreThemeProvider theme={themeV4}>
                <div style={{ backgroundColor: themeV5.palette.background.default, color: themeV5.palette.text.primary, minHeight: '100%', padding: '10px' }}>
                    <div>




                        {
                            ordemServico.id_ordem_compra > 0 &&

                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                item xs={6}
                            >

                                <span style={{ fontSize: 16, color: darkMode ? 'white' : 'black', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Tooltip title="Abrir Ordem de Compra">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => window.open(`/gestao/administracao/ordensdecompras/editar/${ordemServico.id_ordem_compra}`, '_blank')}
                                        >
                                            <SettingsIcon fontSize="small" sx={{ color: darkMode ? 'white' : 'inherit' }} />
                                        </IconButton>
                                    </Tooltip>
                                    Ordem de Compra nº {ordemServico.id_ordem_compra}
                                </span>

                                <span style={{ fontSize: 16, color: darkMode ? 'white' : 'black', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Tooltip title="Importar Itens da Ordem de Compra Associada">
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => handleImportarItensDaOrdemCompra()}
                                        >
                                            <InputIcon fontSize="small" sx={{ color: darkMode ? 'white' : 'inherit' }} />
                                        </IconButton>
                                    </Tooltip>
                                    Importar
                                </span>

                            </Grid>
                        }





                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ padding: 20 }}
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                align="center"
                                item xs={8}
                            >

                                <Autocomplete
                                    id="select-insumo"
                                    options={insumos}
                                    disableCloseOnSelect
                                    getOptionLabel={(insumo) => returnDescricaoInsumo(insumo).replace(/<br \/>/g, '\n')}
                                    value={insumoSelecionado}
                                    getOptionSelected={(option, value) => true}
                                    //  onChange={(e, v) => setInsumoSelecionado(v)}
                                    onChange={(e, v) => handleSetInsumoSelecionado(v)}

                                    filterOptions={(options, { inputValue }) => {
                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                        return options.filter((insumo) => {
                                            const insumoText = returnDescricaoInsumo(insumo).toLowerCase();
                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Insumo " multiline minRows={2} />
                                    )}
                                    renderOption={(option) => (
                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option) }} />
                                    )}
                                />
                            </Grid>


                            <Grid
                                container
                                item xs={2}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <TextField
                                    variant="standard"
                                    name="quantidade"
                                    label="Quantidade"
                                    id="quantidade"
                                    value={quantidade}
                                    onChange={(e) => setQuantidade(e.target.value)}
                                    fullWidth
                                />
                            </Grid>





                            <Grid
                                container
                                item xs={12}
                                justifyContent="center"
                                alignItems="center"
                                style={{ paddingTop: 10 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="observacoesItem"
                                    label="Observações"
                                    id="observacoesItem"
                                    value={observacoesItem}
                                    onChange={(e) => setObservacoesItem(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={2}
                                />
                            </Grid>







                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                item xs={2}
                            >
                                <Button style={{ marginTop: 5 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={(ev) => adicionarItem()}
                                > Adicionar Item  </Button>
                            </Grid>





                        </Grid>




                        <Grid
                            style={{ paddingTop: 5 }}
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                        >
                            {
                                ordemServico.itens_saida_estoque &&
                                <>
                                    <DataGrid
                                        pagination
                                        checkboxSelection
                                        rows={ordemServico.itens_pre_requerimento}
                                        getRowId={(row) => row.id_item_requerimento}
                                        columns={columnsDataGrid}
                                        disableColumnResize={false}
                                        rowHeight={80}
                                        onCellClick={handleCellClick}
                                        onRowClick={handleRowClick}
                                        components={{
                                            Toolbar: CustomToolbar,
                                        }}
                                        sx={{
                                            backgroundColor: themeHelper.paper,
                                            color: themeHelper.text,
                                            height: 400,
                                            width: '100%',
                                            '& .MuiDataGrid-columnHeaders': {
                                                backgroundColor: darkMode ? '#333' : '#f5f5f5',
                                                color: darkMode ? '#fff' : themeHelper.text,
                                            },
                                            '& .cabecalho_azul': {
                                                backgroundColor: 'rgba(0, 0, 255, 1) !important',
                                                color: 'white !important',
                                            },
                                            '& .cabecalho_marrom_claro': {
                                                backgroundColor: 'rgba(184,134,11, 1) !important',
                                                color: 'white !important',
                                            },
                                            '& .cabecalho_verde': {
                                                backgroundColor: 'rgba(0, 100, 0, 1) !important',
                                                color: 'white !important',
                                            },
                                            '& .MuiDataGrid-cell': {
                                                borderBottom: `1px solid ${themeHelper.border}`,
                                            },
                                            '& .MuiDataGrid-columnHeaderTitle': {
                                                fontWeight: 'bold',
                                            },
                                            '& .MuiTablePagination-root': {
                                                color: themeHelper.text,
                                            },
                                            '& .MuiDataGrid-footerContainer': {
                                                backgroundColor: themeHelper.paper,
                                            }
                                        }}
                                    />



                                </>
                            }



                        </Grid>


                    </div>






                </div >
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}


